define('views/parts/form/file',[
    // Libs
    'underscore', 'backbone', 'mustache', 'utils',
    //services
    'services/i18n',
    // templates
    'text!templates/parts/form/file.html',
], function(
    _, Backbone, Mustache, U,
    // services
    i18n,
    // templates
    TFile
) {
    var imageRegexp = /^image\/\w+$/;

    var VFile = Backbone.View.extend({
        template: TFile,
        events: {
            'change .file-input': 'onFileChange',
        },

        regions: {
            input: '.file-input',
            button: '.btn-upload',
            filename: '.filename'
        },

        initialize: function(opt) {
            this.options = _.extend({
                id: this.cid,
                labelposition: 'top',
                title: 'Select a file to upload',
                label: i18n.t('general:Upload a file'),
                hidden: true,
                bare: false,
                icon: 'fa fa-upload',
                btn: 'default',
            }, opt);
        },

        render: function() {
            this.$el.empty().append(
                Mustache.render(this.template, Mustache.getContext(this.options))
            );

            this.generateZones();
            return this;
        },

        updateFilename: function() {
            if (!this.options.bare && this.zone) {
                this.zone.$filename.text(this.file.name);
            }
        },

        getFileMultiple: function() {
            return this.files;
        },
        getFile: function() {
            return this.file;
        },

        reset: function() {
            this.zone.$input.val('');
        },

        isImage: function() {
            var files = this.files;
            if (!this.options.multiple) files = [this.file];

            return _.every(files, function(file) {
                return imageRegexp.test(file.type);
            });
        },

        ////////////
        // events //
        ////////////
        onFileChange: function() {
            this.files = this.zone.$input.prop('files');
            this.file = this.files[0];
            var options = this.options,
                fileParam = options.multiple ? this.files : this.file,
                params = [fileParam, this];

            this.updateFilename();

            _.callback(options.context || this.zone.$input[0], options.callback, params);

            this.trigger.apply(this, ['file:changed'].concat(params));
        },

    });

    return VFile;

});

